module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 57
// module chunks = 0